<template>
    <div>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span style="line-height: 36px;">分销商等级</span>
            <el-button style="float: right;margin-left:10px;" type="success" @click="popNewAddPic">新增等级</el-button>
            <el-button style="float: right;margin-left:10px;" type="danger" @click="popRemovePic">删除等级</el-button>
        </div>
        <div>
            <el-table
                v-loading="table_loading"
                element-loading-text="拼命加载中"
                :data="deviceData"
                stripe
                border
                fit
                height="520"
                @selection-change="handleSelectionChange"
                style="width: 100%">
                <el-table-column
                    type="selection"
                    header-align="center"
                    width="55">
                </el-table-column>
                <el-table-column
                    prop="name"
                    header-align="center"
                    min-width="80"
                    label="等级名">
                </el-table-column>
                <el-table-column
                    prop="selfSale"
                    header-align="center"
                    min-width="80"
                    label="自购数量">
                </el-table-column>
                <el-table-column
                    prop="directSale"
                    header-align="center"
                    min-width="295"
                    label="直销销量">

                </el-table-column>
                <el-table-column
                    prop="teamSale"
                    header-align="center"
                    min-width="120"
                    label="团队销量">
                </el-table-column>
                <el-table-column
                    prop="directSaleFee"
                    header-align="center"
                    min-width="95"
                    label="直营分润">
                </el-table-column>

                <el-table-column
                    prop="sLevelFee"
                    header-align="center"
                    min-width="120"
                    label="同级分润">
                </el-table-column>

                <el-table-column
                    prop="levelFee"
                    header-align="center"
                    min-width="155"
                    label="级差分润">
                </el-table-column>

                <el-table-column
                    prop="shareFee"
                    header-align="center"
                    min-width="155"
                    label="分润">
                </el-table-column>

                <el-table-column
                  prop="see"
                  header-align="center"
                  min-width="240"
                  label="操作">
                  <template scope="scope">
                      <el-button
                          @click="popEditAddPic(scope.row.num)"
                          type="text" size="small">
                          编辑
                      </el-button>
                  </template>
                </el-table-column>
            </el-table>
        </div>

      </el-card>
      <po-add-pic
      :add-show="addPicShow"
      :cur-type="curType"
      :fx-level-obj="fxLevelObj"
      @closeAddAccount="closeAddPic"></po-add-pic>
    </div>
</template>

<script>
import $axios from '../../https/config'
import poNewAddPic from '@/page/fxshop/fxLevelAdd'

export default {
  data () {
    return {
      table_loading: true,
      deviceData: [],
      fxLevelObj:{},
      pageTotal: 0,
      addPicShow: false,
      curType: 1,
      multipleSelection: '',
      row : 1
    }
  },
  created: function () {
    //this.pageNo = 1
    this.queryFxLevelList()
  },
  methods: {
    queryFxLevelList () {
      var params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        //type: 'IMAGE'
      }
      this.table_loading = true
      this.deviceData = []
      var _this = this
      $axios.get('/fx/level/list', params, 'headers', function (res) {
        if (res && res.resultStatus === true) {
          //var resData = []
          if (res.resultData && res.resultData.length > 0) {
            //_this.pageTotal = res.resultData.count
            for (var i = 0; i < res.resultData.length; i++) {
              //var itemData = res.resultData[i]
              res.resultData[i].num=i
              res.resultData[i].shareFee=Math.floor(res.resultData[i].shareFee * 100) / 10000
            }
            _this.deviceData = res.resultData
            //_this.pageTotal = res.resultData.count
          }
        } else {
        }
        _this.table_loading = false
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.queryFxLevelList()
    },
    popNewAddPic () {
      this.addPicShow = true
      this.curType = 1
    },
    popEditAddPic (row) {
      this.addPicShow = true
      this.curType = 2
      //this.row = row
      this.fxLevelObj = this.deviceData[row]

      console.log("before:"+JSON.stringify(this.fxLevelObj));
    },
    handleCurrentChange (val) {
      this.pageNo = val
      this.queryFxLevelList()
    },
    handleSelectionChange (selection) {
      this.multipleSelection = ''
      for (var i = 0; i < selection.length; i++) {
        this.multipleSelection += (selection[i].id + '|')
      }
    },
    closeAddPic () {
      this.addPicShow = false

      this.queryFxLevelList()
    },
    popRemovePic () {
      var that = this
      if (that.multipleSelection.length === 0) {
        that.$message({
          message: '请选择要删除的等级',
          type: 'info'
        })
        return false
      }
      var params = {
        fxLevelIds: that.multipleSelection
      }
      that.$confirm('您已选择等级的ID：' + that.multipleSelection, '是否删除选中的等级', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        $axios.get('/fx/level/del', params, 'headers', function (res) {
          if (res && res.resultStatus === true) {
            that.queryFxLevelList()
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          } else {
          }
        }, function () {
          that.$message({
            type: 'error',
            message: '删除失败!'
          })
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  },
  components: {
    'po-add-pic': poNewAddPic
  }
}
</script>

<style>
    .table_pagination {
      text-align: right;
      margin-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/page/fxshop/fxLevel.vue